<template>
  <div>
    <mdb-modal centered @close="handleClose" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">{{ title }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3" v-html="bodyHtml"></p>
      </mdb-modal-body>
      <mdb-modal-footer class="d-flex">
        <!-- <mdb-btn class="btn btn-isi" @click.native="handleAddOptions"
          >Yes, add more options</mdb-btn
        > -->
        <!-- <mdb-btn class="btn btn-isi" @click.native="clearRequestList"
          >No, close request</mdb-btn
        > -->
        <mdb-btn class="btn btn-isi" @click="handleClose">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title:
        this.options.type == "main" ? "Request sent" : "Request option sent",
    };
  },
  computed: {
    bodyHtml() {
      if (this.options.type == "main") {
        if (this.options.internalUser) {
          return "Your request has been sent to the selected Test Studios.<br/><br/>You will be copied into each of the request e-mails.";
        } else {
          return "Your request has been sent to isi.<br/><br/>You will receive a summary of its data via e-mail.";
        }
      } else {
        return "Your request option has been sent.<br/><br/>Do you want to add more options?";
      }
    },
  },
  created() {
    this.$store.dispatch("clearRequestList", this.$http);
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$store.commit("clearCurrentModal");
    },
    // handleAddOptions() {
    //   this.options.vm.currentComponentPos = 1;
    //   this.$store.commit("clearCurrentModal");
    // },
    // clearRequestList() {
    //   this.$store.dispatch("clearRequestList", this.$http).then(() => {
    //     this.$store.commit("clearCurrentModal");
    //     this.$router.go("Search");
    //   });
    // },
  },
};
</script>

<style>
</style>